<template>
	<a-modal width="65%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2">
			<a-descriptions-item style="width:120px" label="活动名称" name="title" :span="2">{{ form.title }}</a-descriptions-item>
            <a-descriptions-item label="报名时间" name="activityTime">{{ momentFormat(form.activityTime,'YYYY-MM-DD') }} ~ {{
                momentFormat(form.signendTime,'YYYY-MM-DD') }}</a-descriptions-item>
            <a-descriptions-item label="开始时间" name="startDate">{{ momentFormat(form.startDate,'YYYY-MM-DD') }} ~ {{ momentFormat(form.endDate,'YYYY-MM-DD') }}</a-descriptions-item>
            <a-descriptions-item label="联系人" name="contacts">{{ form.contacts }}</a-descriptions-item>
            <a-descriptions-item style="width:120px" label="联系方式" name="phone">{{ form.phone }}</a-descriptions-item>
            <a-descriptions-item label="总结内容" name="content" :span="2">
							<tinymce-editor v-model:value="form.content" disabled preview />
            </a-descriptions-item>
            <a-descriptions-item label="活动图片" name="summaryPicture" :span="2">
                <img-upload v-model:value="form.summaryPicture" :showBtn="false" disabled />
            </a-descriptions-item>
						<a-descriptions-item label="活动视频" name="activityVideo">
							<file-upload v-model:value="form.activityVideo" :showBtn="false" disabled />
					</a-descriptions-item>
            <a-descriptions-item label="活动附件" name="summaryFile">
                <file-upload v-model:value="form.summaryFile" :showBtn="false" disabled />
            </a-descriptions-item>
		</a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin } from "@/mixins";
export default {
	name: "DetailModal",
	components: {
		
	},

	mixins: [formMixin],
	data() {
		return {
			form: {
				
			},
		}
	},
}
</script>
<style scoped lang="less"></style>
